export enum MessagesSectionEnum {
  UnAnswered = 'ubesvart',
  Answered = 'besvart',
  Archived = 'arkiverte',
}
